var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,10c-2.206,0-4,1.794-4,4v1.267L6.955,25.051C6.731,23.335,5.276,22,3.5,22C1.57,22,0,23.57,0,25.5v9   C0,36.43,1.57,38,3.5,38c1.776,0,3.231-1.335,3.455-3.051l2.134,0.672c-0.316,0.346-0.569,0.758-0.723,1.232   c-0.578,1.783,0.402,3.705,2.187,4.283l11.415,3.698h0.001c0.347,0.112,0.698,0.166,1.044,0.166c1.435,0,2.772-0.917,3.238-2.354   c0.171-0.53,0.191-1.068,0.107-1.584L38,44.733V46c0,2.206,1.794,4,4,4s4-1.794,4-4V14C46,11.794,44.206,10,42,10z M24.348,42.031   c-0.238,0.735-1.03,1.14-1.764,0.901l-11.415-3.698c-0.735-0.238-1.14-1.029-0.901-1.764c0.239-0.734,1.029-1.137,1.763-0.9   l11.417,3.698C24.182,40.506,24.585,41.297,24.348,42.031z M5,34.5C5,35.327,4.327,36,3.5,36S2,35.327,2,34.5v-9   C2,24.673,2.673,24,3.5,24S5,24.673,5,25.5v0.167v8.666V34.5z M7,32.866v-5.732l31-9.771v25.273L7,32.866z M44,46   c0,1.103-0.897,2-2,2s-2-0.897-2-2v-0.637V14.637V14c0-1.103,0.897-2,2-2s2,0.897,2,2V46z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,29h-1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1c0.553,0,1-0.447,1-1S55.553,29,55,29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,31h1c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.447-1,1S49.447,31,50,31z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,29h-1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1c0.553,0,1-0.447,1-1S59.553,29,59,29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.828,16.536c0.256,0,0.512-0.098,0.707-0.293l0.707-0.707c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0   l-0.707,0.707c-0.391,0.391-0.391,1.023,0,1.414C52.316,16.438,52.572,16.536,52.828,16.536z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.657,13.707c0.256,0,0.512-0.098,0.707-0.293l0.707-0.707c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0   L54.95,12c-0.391,0.391-0.391,1.023,0,1.414C55.146,13.609,55.401,13.707,55.657,13.707z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,19.364c0.256,0,0.512-0.098,0.707-0.293l0.707-0.707c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0   l-0.707,0.707c-0.391,0.391-0.391,1.023,0,1.414C49.488,19.267,49.744,19.364,50,19.364z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.632,23.1l-0.948,0.316c-0.524,0.175-0.807,0.741-0.632,1.265c0.14,0.419,0.529,0.684,0.948,0.684   c0.104,0,0.212-0.017,0.316-0.052l0.948-0.316c0.524-0.175,0.807-0.741,0.632-1.265S51.155,22.924,50.632,23.1z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.795,24.1c0.104,0,0.212-0.017,0.316-0.052l0.948-0.316c0.524-0.175,0.807-0.741,0.632-1.265s-0.74-0.808-1.265-0.632   l-0.948,0.316c-0.524,0.175-0.807,0.741-0.632,1.265C52.986,23.835,53.376,24.1,53.795,24.1z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.641,22.149c0.14,0.42,0.53,0.685,0.949,0.685c0.104,0,0.211-0.017,0.315-0.051l0.948-0.315   c0.524-0.175,0.808-0.741,0.634-1.265c-0.175-0.524-0.742-0.806-1.265-0.634l-0.948,0.315C56.75,21.06,56.467,21.626,56.641,22.149   z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.364,46.586c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.707,0.707C55.853,48.902,56.108,49,56.364,49   s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L56.364,46.586z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.535,43.757c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.707,0.707c0.195,0.195,0.451,0.293,0.707,0.293   s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L53.535,43.757z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.707,40.929c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L50,43.05c0.195,0.195,0.451,0.293,0.707,0.293   s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L50.707,40.929z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.479,37.849l0.948,0.316c0.104,0.035,0.212,0.052,0.316,0.052c0.419,0,0.809-0.265,0.948-0.684   c0.175-0.523-0.107-1.09-0.632-1.265l-0.948-0.316c-0.522-0.177-1.09,0.108-1.265,0.632S52.954,37.674,53.479,37.849z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265,35.004l-0.948-0.316c-0.523-0.177-1.09,0.108-1.265,0.632s0.107,1.09,0.632,1.265l0.948,0.316   c0.104,0.035,0.212,0.052,0.316,0.052c0.419,0,0.809-0.265,0.948-0.684C52.071,35.745,51.789,35.179,51.265,35.004z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.854,37.532l-0.948-0.315c-0.522-0.173-1.091,0.109-1.265,0.634c-0.174,0.523,0.109,1.09,0.634,1.265l0.948,0.315   c0.104,0.034,0.211,0.051,0.315,0.051c0.419,0,0.81-0.265,0.949-0.685C59.661,38.273,59.378,37.707,58.854,37.532z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.11f71faaeb61dccbfcd42fa5c8e61302.svg";
export { ForwardRef as ReactComponent };